import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'app-formly-field-multi-checkbox',
  templateUrl: './formly-field-multi-checkbox.component.html',
  styleUrls: ['./formly-field-multi-checkbox.component.scss']
})
export class FormlyFieldMultiCheckboxComponent extends FieldType
{
  public onChange(value: any, checked: boolean): void
  {
    this.formControl.patchValue({ ...this.formControl.value, [value]: checked });
    // If all unchecked, we reset to null
    if (this.formControl.value !== undefined && this.formControl.value !== null)
    {
      let count = 0; let falseCount = 0;
      for (const checkValue of Object.values(this.formControl.value))
      {
        count++;
        falseCount += !checkValue ? 1 : 0;
      }
      if (falseCount === count)
      {
        this.formControl.patchValue(null);
      }
    }
    this.formControl.markAsTouched();
  }
}
